import { expected } from '@aloft/toolkit-shared';

import { chunk } from 'lodash';

import { getHistoricalAvgPricePerMonthData } from '../../marketConditions/customAvgPricePerMonth/getHistoricalAvgPricePerMonthData.js';
import { Tkv2MarketConditionsState } from '../../marketConditions/types.js';
import { makeCompMonthMap } from '../../marketConditions/utils/makeCompMonthMap.js';
import { createCompTransactionsFromTkv2 } from '../../marketConditions/zillow/createCompTransactionsFromTkv2.js';
import {
  MonthGrouping,
  ZillowHomeValueIndexTrendsData,
} from '../../marketConditions/zillow/types.js';

type MonthGroupingType = 'historical' | 'projection';

export const MONTHS_PER_TABLE = 6;

export const chunkFilteredHousingTrendsData = (
  filteredHousingTrendsData: ZillowHomeValueIndexTrendsData | undefined,
  marketConditions: Tkv2MarketConditionsState,
) => {
  let data: (MonthGrouping & { type: MonthGroupingType })[];

  if (marketConditions.dateOfSaleAdjustment.selectedMethod === 'customAvgPricePerMonth') {
    const { effectiveDate, dateOfSaleAdjustment, comps, compSequence } = marketConditions;
    const historical = getHistoricalAvgPricePerMonthData(
      effectiveDate,
      expected(dateOfSaleAdjustment.methods?.customAvgPricePerMonth?.trends),
      makeCompMonthMap(createCompTransactionsFromTkv2(comps, compSequence), compSequence),
    );
    data = historical.map((trend) => ({
      ...trend,
      type: 'historical' as MonthGroupingType,
    }));
  } else {
    const historical =
      filteredHousingTrendsData?.historical.map((val) => ({
        ...val,
        type: 'historical' as MonthGroupingType,
      })) ?? [];
    const projection =
      filteredHousingTrendsData?.projection?.map((val) => ({
        ...val,
        type: 'projection' as MonthGroupingType,
      })) ?? [];
    data = historical.concat(projection);
  }

  return chunk(data, MONTHS_PER_TABLE);
};
